import React, { useEffect, useRef, useState } from "react";

function ImageInput({
  name,
  label,
  onChange,
  accept,
  maxFileSize,
  existing,
  onClear,
}) {
  const [error, setError] = useState(null);
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);

  function handleFileChange(event) {
    setError(null);

    if (event.target && event.target.files && event.target.files.length > 0) {
      const newFile = event.target.files[0];

      if (maxFileSize && newFile.size > maxFileSize) {
        setError({
          message: `File size cannot exceed ${(maxFileSize / 1024 / 1024).toFixed(2)} MB`,
        });
        event.target.value = "";
        return;
      }

      if (!accept.includes(newFile.type)) {
        const acceptedTypes = accept
          .split(", ")
          .map((type) => type.split("/")[1])
          .join(", ");
        setError({ message: `File type must be one of the following: ${acceptedTypes}` });
        event.target.value = "";
        return;
      }

      setFile(newFile);
      onChange(event);
    }
  }

  function handleClear() {
    setFile(null);
    setError(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    onChange({ target: { files: [] } });
  }

  useEffect(() => {
    if (onClear === true) {
      handleClear();
    }
  }, [onClear]);

  const preview = file ? URL.createObjectURL(file) : existing || null;

  return (
    <div>
      {label && (
        <label
          htmlFor={name}
          className="block text-sm font-medium mb-1 text-gray-600 dark:text-gray-300"
        >
          {label}
        </label>
      )}
      <div className="pt-2 flex items-center gap-3">
        {preview ? (
          <img
            src={preview}
            alt="Preview"
            className="h-10 w-10 rounded-full object-cover bg-gray-200 dark:bg-gray-700 flex-shrink-0"
          />
        ) : (
          <span className="h-10 w-10 rounded-full bg-gray-200 dark:bg-gray-700 flex-shrink-0 inline-block" />
        )}

        {/* Hidden native input */}
        <input
          type="file"
          name={name}
          id={name}
          ref={fileInputRef}
          onChange={handleFileChange}
          accept={accept}
          className="sr-only"
        />

        {/* Styled trigger + filename */}
        <div className="flex items-center gap-2">
          <label
            htmlFor={name}
            className="cursor-pointer rounded-md px-3 py-1.5 text-sm font-medium ring-1 ring-gray-200 dark:ring-gray-600 bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors duration-150"
          >
            Choose file
          </label>
          <span className="text-sm text-gray-400 dark:text-gray-500 truncate max-w-[180px]">
            {file ? file.name : "No file chosen"}
          </span>
        </div>
      </div>

      {error && (
        <p className="mt-1 text-sm text-danger">{error.message}</p>
      )}
    </div>
  );
}

export { ImageInput };
